import React from 'react';
import { connect } from 'react-redux';
import { tradingTimeInterval } from '../../../../helpers/Common';
import OverviewTable from './OverviewTable';
import { Translate } from 'react-redux-i18n';
import { REDUCER_NAME } from '../reducer';
import {
  REDUCER_NAME as CURRENT_REDUCER_NAME,
  fetchOverviewData,
} from './reducer';
import Responsive from '../../../../common/responsive/Responsive';

class Overview extends React.Component {
  componentDidMount() {
    const { fetchOverviewData } = this.props;
    fetchOverviewData();
  }

  render() {
    const {
      component = {},
      overViewData: { topGrowths, topLeaders, topMomentums, topValues },
    } = this.props;
    return (
      <div className="fiinTradeStrategy d-flex flex-fill flex-column">
        <div className="px-20">
          <Responsive
            component={{
              ...component,
              width: Math.max(component.width, 400),
            }}
            margin={10}
            offsetWidth={40}
            XS_SIZE={500}
            numColumnLgSize={2}
            numColumnMdSize={2}
          >
            {() => (
              <OverviewTable
                data={topLeaders}
                titleHeaderTable={<Translate value="strategy.topFiveLeader" />}
                colorLeft="#9983d8"
                colorRight="#9983d8"
              />
            )}
            {() => (
              <OverviewTable
                data={topValues}
                titleHeaderTable={<Translate value="strategy.topFiveValue" />}
                colorLeft="#f5761d"
                colorRight="#f5761d"
              />
            )}
            {() => (
              <OverviewTable
                data={topGrowths}
                titleHeaderTable={<Translate value="strategy.topFiveGrowth" />}
                colorLeft="#f4485e"
                colorRight="#f4485e"
              />
            )}
            {() => (
              <OverviewTable
                data={topMomentums}
                titleHeaderTable={
                  <Translate value="strategy.topFiveMomentum" />
                }
                colorLeft="#2965cc"
                colorRight="#2965cc"
              />
            )}
          </Responsive>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  component: state[REDUCER_NAME].component,
  overViewData: state[CURRENT_REDUCER_NAME].overViewData,
});

const mapDispatchToProps = {
  fetchOverviewData,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Overview);
